import {
  OrderedList,
  type OrderedListProps,
} from '@frontend/legacy-components';

export type ResponseOrderedListProps = OrderedListProps;

/**
 * Base ordered list component for Response.
 * Provides consistent styling for ordered lists in AI responses.
 */
export const ResponseOrderedList = ({
  className,
  children,
  ...props
}: ResponseOrderedListProps) => {
  return (
    <OrderedList
      marginLeft={4}
      className={className}
      fontFamily="default"
      fontSize="md"
      lineHeight="md"
      pb={0.5}
      {...props}
    >
      {children}
    </OrderedList>
  );
};
